const API_URL = 'https://api-dashboard.getsensync.com/api/sparing';

export { API_URL };
